export default __webpack_public_path__ + "23fdfee016d531b94aaf4ae81497e172.png";